import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { LoadingPopupComponent } from 'src/app/components/ui/loading-popup/loading-popup.component';
import { DeviceStateService } from 'src/app/services/device-state/device-state.service';
import { DeviceService } from 'src/app/services/devices/device.service';
import { ModalService } from 'src/app/services/modal/modal.service';

// El 200 de setModuleElement no confirma que el relé aplicara el valor (ver DeviceStateService):
// quien lo confirma es la notificación de websocket que llega por el mismo 'select'. Techo de espera.
const SAVE_TIMEOUT_MS = 120000;

// AstroLum expone un único relé/canal vía el módulo 'relays'. El id real del elemento
// (uid=0) no llega al cliente por REST -- confirmado en la app (Settings/Channels): el nombre
// del elemento ("relay_1") no es válido como id de URL, solo "0" lo es.
const RELAY_ELEMENT_ID = '0';

@Component({
    selector: 'app-channels',
    templateUrl: './channels.component.html',
    standalone: false
})
export class ChannelsComponent implements OnInit, OnDestroy {

  @Input()
  allSettings = false;

  device = '';

  permanent = false;
  originalPermanent = false;

  successMessage = false;
  error = '';
  modalLoad: NgbModalRef;
  private sub?: Subscription;
  // Valor pedido en save() mientras se espera la confirmación real por websocket. null = nada pendiente.
  private pendingPermanent: boolean | null = null;
  private saveTimeout?: ReturnType<typeof setTimeout>;

  constructor(
    private _aRoute: ActivatedRoute, public _dService: DeviceService, private _modal: ModalService,
    private _state: DeviceStateService, private _translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this._aRoute.parent?.parent?.params
      .subscribe((params: Params) => this.device = params['serial']);

    // Compartido con el dashboard: si se viene de él, no se vuelve a pedir. No pisa una edición sin guardar.
    this.sub = this._state.select(this.device, 'relays', 'all').subscribe(({ cfg }) => {
      if (cfg?.permanent === undefined) return;
      const value = !!cfg.permanent;
      if (this.pendingPermanent !== null) {
        if (value !== this.pendingPermanent) return; // todavía no es el valor confirmado por el dispositivo
        clearTimeout(this.saveTimeout);
        this.pendingPermanent = null;
        this.modalLoad.close();
        this.successMessage = true;
        setTimeout(() => this.successMessage = false, 10000);
      } else if (!this.changed) {
        this.permanent = value;
      }
      this.originalPermanent = value;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    clearTimeout(this.saveTimeout);
  }

  get changed(): boolean {
    return this.permanent !== this.originalPermanent;
  }

  save(): void {
    this.modalLoad = this._modal.open(LoadingPopupComponent);
    const desired = this.permanent;

    this._dService.setModuleElement(this.device, 'relays', { cfg: { permanent: desired } }, RELAY_ELEMENT_ID)
      .subscribe(() => {
        // No cierra el modal ni da el guardado por bueno aquí: lo confirma el websocket (ver ngOnInit).
        this.pendingPermanent = desired;
        this.saveTimeout = setTimeout(() => {
          this.pendingPermanent = null;
          this.permanent = this.originalPermanent;
          this.modalLoad.close();
          this.error = this._translate.instant('notResponse');
          setTimeout(() => this.error = '', 10000);
        }, SAVE_TIMEOUT_MS);
      }, err => {
        console.error(err);
        this.error = err.error?.message || '';
        setTimeout(() => this.error = '', 10000);
        this.modalLoad.close();
      });
  }

  restore(): void {
    this.permanent = this.originalPermanent;
  }

}
